<template>

    <v-toolbar card prominent :color="darkMode===false?'indigo':''" :class="darkMode===false?'white--text':''">

        <v-toolbar-side-icon :dark="darkMode===false" v-if="this.$vuetify.breakpoint.smAndDown" @click.native="triggerSideNav">
            <v-icon class="icon-menu"></v-icon>
        </v-toolbar-side-icon>

        <!--<v-btn :dark="darkMode===false" v-if="isMain===false && this.$vuetify.breakpoint.smAndDown" icon to="/">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>-->

        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-spacer v-if="isMain===true"></v-spacer>

        <v-btn
              v-if="isMain===true"
              icon
              :dark="darkMode===false"
              :disabled="resetPossible===false"
              @click="doReset"
        >
            <v-icon class="icon-replay"></v-icon>
        </v-btn>

        <!--<v-menu v-if="isMain===true" bottom left transition="slide-y-transition">
            <v-btn
                  slot="activator"
                dark
                icon
            >
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>

            <v-list>
                <v-list-tile @click="loginWithGoogle=true">
                    <v-list-tile-title><v-icon class="mr-3">mdi-google</v-icon>Mit Google anmelden</v-list-tile-title>
                </v-list-tile>

                <v-list-tile to="/feedback">
                    <v-list-tile-title><v-icon class="mr-3">mdi-message-text</v-icon>Feedback senden</v-list-tile-title>
                </v-list-tile>

            </v-list>
        </v-menu>-->

    </v-toolbar>

</template>

<script>
    export default {
        name: 'Toolbar',
        props: {
            title: {
                type: String,
                default: ''
            },
            isMain: {
                type: Boolean,
                default: false
            }
        },
        /*data: () => ({
            installIsPossible: false
        }),*/

        computed: {

            darkMode: {
                get() {
                    return this.$store.getters.darkMode;
                }
            },
            resetPossible: {
                get() {
                    return this.$store.getters.resetAvailable;
                }
            }
        },
        methods: {
            triggerSideNav() {
                this.$store.dispatch("sideNav", true);
            },
            doReset() {
                this.$store.dispatch("clearValues");

                //this._showSnackbar({text: "Felder wurden geleert.", position: "top", color: "green lighten-1"});
            }

        }
        /*mounted() {

            console.log("is created");

            if ( this.$deferredPrompt !== null ) {
                console.log("install is possible");
                this.installIsPossible = true;
            }
            else {
                console.log("install NOT possible");
                this.installIsPossible = false;
            }
        }*/
    }
</script>

<style scoped>

</style>
